import * as React from "react";
import { forwardRef } from "react";
const SvgDownChevron = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 404.257 404.257", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M386.257 114.331L202.128 252.427 18 114.331l-18 24 202.128 151.596 202.129-151.596z" }));
const ForwardRef = forwardRef(SvgDownChevron);
export { ForwardRef as ReactComponent };
